export const data = {
  logbookName: "Oil Record 1",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  features: {},
  content: [
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          inherited: {
            label: {
              align: "flex-end",
              textAlign: "center",
              padding: "8px",
              style: "solid",
            },
          },
          content: [
            {
              item: "1",
              text: "Name of Ship",
              component: "label",
            },
            {
              item: "1",
              text: "Distinctive number or letters",
              component: "label",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      marginBottom: "22px",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "text",
            },
            {
              item: "1",
              component: "text",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      label: {
        textAlign: "center",
        padding: "8px",
        style: "solid",
        text: "MACHINERY SPACE OPERATIONS",
      },
      content: [
        {
          group: "ENG",
          layout: "horizontal",

          inherited: {
            label: {
              align: "flex-end",
              textAlign: "center",
              padding: "8px",
              style: "solid",
            },
          },
          content: [
            {
              item: "1",
              text: "",
              width: "48px",
              minWidth: "48px",
              component: "label",
            },
            {
              item: "1",
              text: "Date",
              width: "25%",
              component: "label",
            },
            {
              item: "1",
              text: "Code (Letter)",
              width: "25%",
              component: "label",
            },
            {
              item: "1",
              text: "Item Number",
              width: "25%",
              component: "label",
            },
            {
              item: "1",
              text: "Record of Operations",
              width: "25%",
              component: "label",
            },
            {
              item: "1",
              text: "",
              width: "48px",
              minWidth: "48px",
              component: "label",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "vertical",
      panel: "ID1",
      marginBottom: "22px",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          copyRow: true,
          addRow: true,
          moveRow: true,
          deleteRow: true,
          content: [
            {
              item: "1",
              text: "#",
              width: "48px",
              minWidth: "48px",
              clear: true,
              function: "moveRow",
              component: "button",
            },
            {
              item: "1",
              component: "text",
              width: "25%",
            },
            {
              item: "1",
              component: "text",
              width: "25%",
              info: "test-id-1",
            },
            {
              item: "1",
              width: "25%",
              component: "text",
              info: "test-id-1",
            },
            {
              item: "1",
              width: "25%",
              component: "text",
            },
            {
              item: "1",
              text: "X",
              width: "48px",
              minWidth: "48px",
              function: "delRow",
              clear: true,
              component: "button",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          inherited: {
            label: {
              align: "flex-end",
              textAlign: "center",
              padding: "8px",
              style: "solid",
            },
          },
          content: [
            {
              item: "1",
              text: "Signature of officer in charge",
              component: "label",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "list",
            },
          ],
        },
      ],
    },
  ],
};

export const infoData = {
  logbookName: "Oil Record 1",
  logbookVersion: "1.0.0",
  primaryVerifiers: [],
  secondaryVerifiers: [],
  regulatory: 0,
  author: "",
  features: {},
  content: [
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "text",
            },
            {
              item: "1",
              component: "text",
            },
          ],
        },
      ],
    },
    {
      group: "ENG",
      layout: "horizontal",
      panel: "ID1",
      content: [
        {
          group: "ENG",
          layout: "horizontal",
          content: [
            {
              item: "1",
              component: "list",
            },
          ],
        },
      ],
    },
  ],
};
